import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGridPlugin from '@fullcalendar/timegrid';
// import listPlugin from '@fullcalendar/list';
import googleCalendarPlugin from '@fullcalendar/google-calendar';

// import moment from 'moment';

export function generateCalendar(data) {

  const calendarEl = data.next.container.querySelector('.calendar');

  if (calendarEl) {
    const calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin, googleCalendarPlugin],
      googleCalendarApiKey: 'AIzaSyD3tlVGn3YEznpnioaIY7DlWb_5vmrUrxs',
      events: {
        googleCalendarId: 'bgi4nmkvqi1ti8u2kj46kijgog@group.calendar.google.com',
      },
      titleFormat: function(date) {
        return date.date.year + '.' + (date.date.month + 1).toString().padStart(2, '0');
      },
      height: 'auto',
      contentHeight: 'auto',
      buttonText: {
        today: '今日',
        // next: '次へ',
        // prev: '前へ',
        // その他のボタンに対しても同様に設定
      },
      displayEventTime: false,  // 開始時間を表示するかどうか
      eventContent: function(info) {
        if (info.event.title.includes('閉室')) {
          return {html: ''};
        } else if (info.event.title.includes('午後') || info.event.title.includes('午前')) {
          return {html: ''};
        } else {
          return {html: info.event.title};
        }
      },

      eventDidMount: function(info) {
        // イベントの開始日を取得
        const eventDate = info.event.startStr;

        // カレンダー内の全ての日付セルを検索
        const allCells = calendarEl.querySelectorAll('.fc-daygrid-day');

        allCells.forEach(cell => {
          // セルの日付データを取得
          const cellDate = cell.getAttribute('data-date');

          if (cellDate === eventDate) {
            // 条件に合致する場合、セルにクラスを追加
            if (info.event.title.includes('閉室')) {
              cell.classList.add('calendar_close');
            } else if (info.event.title.includes('午後') || info.event.title.includes('午前')) {
              cell.classList.add('calendar_half');
            }
          }
        });
      },
    });
    calendar.render();
  }
}
